export const getContactUrl = (workspaceId: string, id: number) => `/business/workspaces/${workspaceId}/contacts/${id}`;

export const getNotesUrl = (workspaceId: string, id: number) =>
  `/business/workspaces/${workspaceId}/contacts/${id}/notes`;

export const getNoteUrl = (workspaceId: string, contactId: number, id: number) =>
  `/business/workspaces/${workspaceId}/contacts/${contactId}/notes/${id}`;
